import React from 'react'
import ReactDOM from 'react-dom'
import 'focus-visible'
import 'normalize.css'
import reportWebVitals from './reportWebVitals'
import * as serviceWorkerRegistration from './serviceWorkerRegistration'
import App from './App'
import './index.scss'

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root'),
)

serviceWorkerRegistration.register()

reportWebVitals()
